import { isInIframe } from "@lib/utils/iframe";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      isInIframe,
    },
  };
});
